import CallbackService from '../services/callback.service';
import CrmService, { isDniproCity } from '../services/crm.service';

export async function sendMail(data) {
  const country =
    window.location.hostname.split('.')[
      window.location.hostname.split('.').length - 1
    ];
  let sendData = {
    emails: data.selectedCity.email,
    city: data.selectedCity.title[country],
    phone: data.phone,
    contact_person: data.contact_person,
    group: data.group,
    office: data.office,
    mailer: `info@soroban.${country}`,
  };
  // Send the same lead to the new CRM (crm.soroban.ua) — Dnipro only —
  // independently of the existing Bitrix flow so a CRM error never affects the
  // current behavior.
  if (isDniproCity(data.selectedCity)) {
    CrmService.SendLead(sendData).catch(() => {});
  }
  const res = await CallbackService.SendCallback(sendData);
  if (res && res.response === 'ok') {
    window.dataLayer.push({ event: 'lead' });
  }
  return res;
}
